import { deserialize } from "libs/cerialize";

export class FlowOperationModel {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}